/**
 * Query param of the OdiloTK book page a shared-highlight link points to
 * (`<otkDomain>/info/<bookId>?annotationSharedId=<sharedId>`). That page opens the reader on its
 * own when the param is present.
 */
export const SHARED_LINK_PARAM = 'annotationSharedId';
